import { defineComponent as Z, openBlock as o, createElementBlock as H, mergeProps as d, unref as e, renderSlot as m, createElementVNode as n, createCommentVNode as p } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const i = { key: 0 }, A = { key: 1 }, M = { key: 2 }, v = { key: 3 }, g = { key: 4 }, f = { key: 5 }, h = {
  name: "ScalarIconLayout"
}, w = /* @__PURE__ */ Z({
  ...h,
  props: {
    label: {},
    weight: {}
  },
  setup(V) {
    const a = V, { bind: r, weight: l } = u(a);
    return (s, t) => (o(), H("svg", d({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(r)), [
      m(s.$slots, "default"),
      e(l) === "bold" ? (o(), H("g", i, t[0] || (t[0] = [
        n("path", { d: "M216,36H40A20,20,0,0,0,20,56V200a20,20,0,0,0,20,20H216a20,20,0,0,0,20-20V56A20,20,0,0,0,216,36Zm-4,24V92H44V60ZM44,116H92v80H44Zm72,80V116h96v80Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (o(), H("g", A, t[1] || (t[1] = [
        n("path", {
          d: "M104,104V208H40a8,8,0,0,1-8-8V104Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,16V96H40V56ZM40,112H96v88H40Zm176,88H112V112H216v88Z" }, null, -1)
      ]))) : e(l) === "fill" ? (o(), H("g", M, t[2] || (t[2] = [
        n("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM40,56H216V96H40ZM216,200H112V112H216v88Z" }, null, -1)
      ]))) : e(l) === "light" ? (o(), H("g", v, t[3] || (t[3] = [
        n("path", { d: "M216,42H40A14,14,0,0,0,26,56V200a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V56A14,14,0,0,0,216,42ZM40,54H216a2,2,0,0,1,2,2V98H38V56A2,2,0,0,1,40,54ZM38,200V110H98v92H40A2,2,0,0,1,38,200Zm178,2H110V110H218v90A2,2,0,0,1,216,202Z" }, null, -1)
      ]))) : e(l) === "regular" ? (o(), H("g", g, t[4] || (t[4] = [
        n("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,16V96H40V56ZM40,112H96v88H40Zm176,88H112V112H216v88Z" }, null, -1)
      ]))) : e(l) === "thin" ? (o(), H("g", f, t[5] || (t[5] = [
        n("path", { d: "M216,44H40A12,12,0,0,0,28,56V200a12,12,0,0,0,12,12H216a12,12,0,0,0,12-12V56A12,12,0,0,0,216,44ZM40,52H216a4,4,0,0,1,4,4v44H36V56A4,4,0,0,1,40,52ZM36,200V108h64v96H40A4,4,0,0,1,36,200Zm180,4H108V108H220v92A4,4,0,0,1,216,204Z" }, null, -1)
      ]))) : p("", !0)
    ], 16));
  }
});
export {
  w as default
};
